import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import SweetAlert from "react-bootstrap-sweetalert";
import { FaArrowLeft, FaArrowRight, FaListAlt, FaImage } from "react-icons/fa";
import { MdArrowLeft, MdArrowRight, MdArrowRightAlt, MdDelete, MdModeEdit, MdPlayArrow } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const Images = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_images, setLoadingimages] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [images, setimages] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });


  const [current_page, setCurrentPage] = useState(1);
  const [last_page, setLastPage] = useState(1);

  const [search, setSearch] = useState('');
  const { candidato_id, candidato_name, processo_id } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [image_id, setimageId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getimages = async (page, search) => {

    let response = await Request.Get(`faculdade/get_images_candidato/${processo_id}/${candidato_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setimages(response.images);
      if (response.images.length > 0) {
        setImageSelect(response.images[0]);

      }

      // setPagination({...response.pagination});
      setCurrentPage(response.pagination.current_page);
      setLastPage(response.pagination.last_page);

      setLoadingScreen(false);
      setLoadingimages(false);


    }
  };

  const [image_select, setImageSelect] = useState(null);

  const Deleteimage = async (image_id) => {

    let response = await Request.Delete(`faculdade/delete_image/${image_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getimages(current_page, search_oficial);



  };

  useEffect(() => {
    Getimages(1, search_oficial);
  }, []);






  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">{t("ui_aqui_ficam_os_registros_de_tela_do_candidato_dd8ad37e")}{candidato_name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search placeholder={t("legacy_pesquisar_pelo_nome_da_imagem")} ValueChange={(value) => {
              clearTimeout(pesquisarTimeout);
              setSearchOficial(value);

              pesquisarTimeout = setTimeout(() => {
                // let page = { ...pagination };
                // page.current_page = 1;
                // setPagination(page);
                setCurrentPage(1);
                setLoadingimages(true);

                Getimages(1, value);

              }, 500);
            }} />


                        {/* <Link to={{
              pathname: "/images/register/" + candidato_id,
              // state: {
              //     course_id: id
              // }
              }} style={{ textDecoration: "none" }}>
              <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t("action_add_image")}</p></Button>
              </Link> */}
                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("label_name")}</th>
                                        <th>{t("legacy_data")}</th>
                                        <th data-priority="3">{t("label_actions")}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_images == false && images.map((item, id) =>

                  <tr style={{}} key={id}>
                                            <td>{item.path.split('/')[item.path.split('/').length - 1]}</td>
                                            <td>{moment(item.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>

                                            <td>
                                                <div className="actions-group">
                                                <a href={item.url} target="_blank">

                                                <span
                          onClick={() => {

                          }}
                          className="inline-flex align-center jcc bg-warning icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("legacy_gerenciar_imagem")}>

                                                    <BsFillEyeFill size={17} color="white" />
                                                </span>
                                                </a>
                                                {/* <Link to={`/images/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                        <span
                        className="inline-flex align-center jcc bg-info icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                        data-toggle="tooltip"
                        title="Editar questão"
                        >
                        <MdModeEdit color="white" size={17} />
                        </span>
                        </Link>
                        <span
                        onClick={(e) => {
                        setimageId(item.id);
                        setShowWarning(true);
                        e.stopPropagation();
                        }}
                        className="inline-flex align-center jcc bg-danger icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title={t("action_delete_image")}
                        >
                        <MdDelete size={17} color="white" />
                        </span> */}

                                                </div>
                                                </td>

                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_images == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_images == false && images.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("empty_no_records_found")} icon="👤" />

                        </div>
                    </div>}

                    <Pagination
            className={last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={last_page}
            // value={pagination.current_page}
            page={current_page}
            onChange={(_, value) => {
              setLoadingimages(true);
              console.log(_, value);
              console.log(pagination);
              setCurrentPage(value);
              // let page = { ...pagination };
              // page.current_page = value;
              // setPagination(page);
              Getimages(value, search_oficial);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_image={this.get_image.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingimages(true);
            Deleteimage(image_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_esta_imagem_ela_nao_estara_mais_disponi_fba6b358")}


        </SweetAlert>


            </div>

        </div>);

};

export default Images;
